import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Typography } from "antd";
import { useLogin } from "../hooks/useAuth";
import type { LoginRequest } from "../types";

const { Title, Text } = Typography;

export function LoginForm() {
	const [form] = Form.useForm<LoginRequest>();
	const { mutate: login, isPending } = useLogin();

	const onFinish = (values: LoginRequest) => {
		login(values);
	};

	return (
		<Card className="w-full max-w-md shadow-lg">
			<div className="text-center mb-8">
				<Title level={2} className="!mb-2">
					WeddingHall Statistics
				</Title>
				<Text type="secondary">Tizimga kirish</Text>
			</div>

			<Form
				form={form}
				name="login"
				onFinish={onFinish}
				layout="vertical"
				requiredMark={false}
				size="large"
			>
				<Form.Item
					name="username"
					label="Login"
					rules={[
						{ required: true, message: "Login kiritilishi shart" },
					]}
				>
					<Input
						prefix={<UserOutlined className="text-gray-400" />}
						placeholder="admin"
						autoComplete="username"
					/>
				</Form.Item>

				<Form.Item
					name="password"
					label="Parol"
					rules={[
						{ required: true, message: "Parol kiritilishi shart" },
						{ min: 6, message: "Parol kamida 6 belgidan iborat bo'lishi kerak" },
					]}
				>
					<Input.Password
						prefix={<LockOutlined className="text-gray-400" />}
						placeholder="Parol"
						autoComplete="current-password"
					/>
				</Form.Item>

				<Form.Item className="!mb-0">
					<Button type="primary" htmlType="submit" loading={isPending} block>
						Kirish
					</Button>
				</Form.Item>
			</Form>
		</Card>
	);
}
